<template>
  <div class="volunteer">
    <div class="volunteer__wrapper my-16">
      <v-row no-gutters v-if="$vuetify.breakpoint.mdAndUp">
        <v-col cols="7" class="px-14 ">
          <div class="volunteer__name d-flex my-12">
            <h2>{{ volunteer.name }}</h2>
            <h2 class="ml-4" style="color: #CECED8">Волонтёр</h2>
          </div>
          <v-row>
            <v-col cols="4" class="volunteer__timeline">
              <div
                class="volunteer__timeline-item mb-8"
                v-for="(item, index) in volunteer.timeline"
                :key="index"
              >
                <div class="volunteer__timeline-item-year d-flex align-center">
                  <h3>{{ item.year }}</h3>
                  <div
                    class="volunteer__timeline-item-year-line ml-2"
                    v-if="index !== volunteer.timeline.length - 1"
                  ></div>
                </div>
                <div class="volunteer__timeline-item-role">
                  <p>{{ item.role }}</p>
                </div>
              </div>
            </v-col>
            <v-col cols="7" offset="1">
              <div
                class="volunteer__question-wrapper"
                @scroll="scrollDesc = true"
              >
                <div
                  class="volunteer__question"
                  v-for="(item, index) in volunteer.description"
                  :key="index"
                >
                  <p>
                    <span
                      style="font-family: 'Roboto', sans-serif !important; color: #A0A0AE"
                      >{{ item.question }}</span
                    >
                    {{ item.ask }}
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="5">
          <v-card width="100%" height="100vh" flat tile>
            <v-img
              width="100%"
              height="100%"
              :src="require('@/assets/img/volunteers/' + volunteer.img)"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="#FFA903" />
                </v-row>
              </template>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-else style="font-size: 16px !important">
        <v-col cols="12">
          <v-img
            width="100vw"
            height="100vw"
            :src="require('@/assets/img/volunteers/' + volunteer.img)"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="#FFA903" />
              </v-row>
            </template>
            <v-btn
              tile
              color="#fff"
              elevation="0"
              width="150"
              height="50"
              class="cancelButton"
              to="/team"
            >
              <v-icon>mdi-chevron-left</v-icon>
              Волонтеры
            </v-btn>
          </v-img>
        </v-col>
        <v-col cols="12" class="pl-5">
          <h2>{{ volunteer.name }}</h2>
        </v-col>
        <v-col cols="12" class="volunteer__timeline">
          <v-row class="pl-5">
            <v-col
              cols="4"
              class="volunteer__timeline-item"
              v-for="(item, index) in volunteer.timeline"
              :key="index"
            >
              <div class="volunteer__timeline-item-year d-flex align-center">
                <h3>{{ item.year }}</h3>
                <div
                  class="volunteer__timeline-item-year-line ml-2"
                  v-if="index !== volunteer.timeline.length - 1"
                ></div>
              </div>
              <div class="volunteer__timeline-item-role">
                <p>{{ item.role }}</p>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="px-5">
          <div class="">
            <div
              class="volunteer__question"
              v-for="(item, index) in volunteer.description"
              :key="index"
            >
              <p style="font-size: 16px !important">
                <span
                  style="font-family: 'Roboto', sans-serif !important; color: #A0A0AE"
                  >{{ item.question }}</span
                >
                {{ item.ask }}
              </p>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Volunteer",
  computed: {
    id() {
      return this.$route.params.id;
    },
    volunteer() {
      return this.$store.getters.getVolunteerById(this.id);
    }
  },
  data: () => ({
    scrollDesc: false
  }),
  mounted() {}
};
</script>

<style lang="sass" scoped>
@import "./src/assets/style/vars"
@media (max-width: 600px)
  .volunteer
    height: 100% !important
.volunteer
  width: 100%
  height: 100vh
  overflow: hidden
  &__timeline
    &-item
      &-year
        &-line
          width: 1.2rem
          height: 3px
          background-color: $prime
      &-role
        p
          font-size: 16px
          line-height: 16px
          letter-spacing: 0.02em
          color: $second
  &__question-wrapper
    overflow: scroll !important
    height: 100vh
    transition: all .4s ease
    &::-webkit-scrollbar
      width: 0 !important
.cancelButton
  color: #A0A0AE
  font-weight: 700
  font-size: 16px
  font-family: 'Roboto', sans-serif !important
  text-transform: unset
  display: flex
  align-items: center
  position: absolute
  left: 0
  bottom: 0
</style>
